/// <amd-module name="SuiteCommerce.ShippingBar.Common.Instrumentation.Helper"/>
define("SuiteCommerce.ShippingBar.Common.Instrumentation.Helper", ["require", "exports", "SuiteCommerce.ShippingBar.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ComponentArea = 'SC Shipping Bar';
    var ExtensionVersion = '1.1.6';
    var QueueNameSuffix = '-ShippingBar';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (container) {
            Instrumentation_1.default.initialize({
                environment: container.getComponent('Environment'),
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                }
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
